import React, { createContext, useContext, useState } from 'react';
import PropTypes from 'prop-types';
import ImageViewer from './ImageViewer';

const ImageViewerContext = createContext();

export const useImageViewer = () => {
  const context = useContext(ImageViewerContext);
  if (!context) {
    throw new Error('useImageViewer must be used within an ImageViewerProvider');
  }
  return context;
};

export const ImageViewerProvider = ({ children }) => {
  const [visible, setVisible] = useState(false);
  const [images, setImages] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  const openImageViewer = (imageList, startIndex = 0) => {
    if (!Array.isArray(imageList) || imageList.length === 0) {
      console.warn('ImageViewer: 图片列表不能为空');
      return;
    }

    // 确保图片对象有必要的属性
    const processedImages = imageList.map((img, index) => ({
      url: typeof img === 'string' ? img : img.url || img.src,
      title: img.title || img.alt || `图片 ${index + 1}`,
      ...img,
    }));

    setImages(processedImages);
    setCurrentIndex(Math.max(0, Math.min(startIndex, processedImages.length - 1)));
    setVisible(true);
  };

  const closeImageViewer = () => {
    setVisible(false);
    setImages([]);
    setCurrentIndex(0);
  };

  const handleIndexChange = newIndex => {
    setCurrentIndex(newIndex);
  };

  const value = {
    openImageViewer,
    closeImageViewer,
    visible,
    images,
    currentIndex,
  };

  return (
    <ImageViewerContext.Provider value={value}>
      {children}
      <ImageViewer
        visible={visible}
        images={images}
        currentIndex={currentIndex}
        onClose={closeImageViewer}
        onIndexChange={handleIndexChange}
      />
    </ImageViewerContext.Provider>
  );
};

ImageViewerProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
